@for (toast of toastService.toasts(); track $index) {
  <ngb-toast
    [class]="toast.classname"
    [autohide]="true"
    [delay]="toast.delay"
    (hidden)="toastService.remove(toast)"
  >
    {{ toast.text }}
  </ngb-toast>
}
